import { stats } from "@api/stores/users/stats/path";

export const users = {
  stats,
};
